import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import React, { useState } from 'react'

import styles from './Dialog.module.sass'

const PromptDialog = (props) => {
	const { className, data, resolve, dismiss } = props
	const { i18n } = useGlobal()
	const [justification, setJustification] = useState('')

	const handleSubmit = (e) => {
		e.preventDefault()
		resolve && resolve(justification)
	}

	return (
		<div className={`${styles['root'] || ''} ${className || ''}`}>
			<div>
				<small className={styles['dialog-title']}>
					{data?.label || i18n`Are you sure?`}
				</small>
			</div>
			<form
				id={'form_prompt'}
				className={`${styles['root'] || ''} ${
					styles['--is-larger'] || ''
				} ${className || ''}`}
				// disabled={isLoading}
				onSubmit={handleSubmit}
			>
				<TextInput
					placeholder={i18n`Justification`}
					value={justification}
					multiline
					noResize
					rows='3'
					required
					onChange={(e) => {
						setJustification(e.target.value)
					}}
				/>
				<HStack
					className={styles['actions-container']}
					gap='xsmall'
					justify='flex-end'
				>
					<ActionButton type='button' secondary onClick={dismiss}>
						<small>
							<strong>{i18n`Cancel`}</strong>
						</small>
					</ActionButton>
					<ActionButton primary form={'form_prompt'}>
						<small>
							<strong>{i18n`Send`}</strong>
						</small>
					</ActionButton>
				</HStack>
			</form>
		</div>
	)
}

export default PromptDialog
